import { QuestionDifficulty } from 'types';

export const generateDifficultyColor = (difficulty: QuestionDifficulty) => {
	switch (difficulty) {
		case QuestionDifficulty.Easy:
			return '#39D98A';
		case QuestionDifficulty.Medium:
			return '#FDAC42';
		case QuestionDifficulty.Hard:
			return '#FF5C5C';
	}
};
